import { useState } from 'react';
import { useSetting } from '../../../util/useSetting';

export default function DropDownSelection(props) {
    const { fontSize } = useSetting();
    const value = props.value;
    const options = props.options
    const handleSelect = (item) => {
        if (props.onUpdate)
            props.onUpdate(item);
        setIsOpen(false);
    }
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className='flex flex-col w-[120px] text-center h-full px-[12px] py-[4px] rounded-[8px] bg-[white] font-[700] gap-[2px] relative' style={{ fontSize }}>
            <button className='flex flex-row items-center gap-[4px] w-full justify-center text-left' onClick={() => setIsOpen(!isOpen)}>
                <div className='flex-1 text-ellipsis overflow-hidden whitespace-nowrap'>{value}</div>
                <img src='/secondary/down.png' className='w-[12px]' alt='dropdown' />
            </button>
            {isOpen && (
                <div className='flex flex-col gap-[4px] text-black absolute top-[100%] left-0 z-[10] bg-[white] p-[4px] rounded-[8px] w-[300px] text-left mb-[12px]' style={{boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                    {options.map((option, index) => (
                        <button key={index} onClick={() => handleSelect(option)} className='w-full text-left'>
                            {option}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}